import { customerConstants } from '../constants'
import { customerService } from '../services'
import { alertActions } from './alert.actions'

export const customerActions = {
	getCustomerByYaa,
	getCustomerInfoByYaa,
	bookingCustomer,
	deleteBookingCustomer,
}

function getCustomerByYaa(status) {
	return dispatch => {
		dispatch(request())

		customerService.getCustomerByYaa(status).then(
			customers_book => {
				setTimeout(() => {
					dispatch(success(customers_book))
				}, 500)
			},
			error => {
				dispatch(failure(error.toString()))
				dispatch(alertActions.error(error.toString()))
			}
		)
	}

	function request() {
		return { type: customerConstants.GET_CUSTOMER_BY_AUTH_AND_STATUS_REQUEST }
	}

	function success(customers_book) {
		return { type: customerConstants.GET_CUSTOMER_BY_AUTH_AND_STATUS_SUCCESS, customers_book }
	}

	function failure(error) {
		return { type: customerConstants.GET_CUSTOMER_BY_AUTH_AND_STATUS_FAILURE, error }
	}
}

function getCustomerInfoByYaa() {
	return dispatch => {
		dispatch(request())

		customerService.getCustomerInfoByYaa().then(
			customer_info => {
				setTimeout(() => {
					dispatch(success(customer_info))
				}, 1000)
			},
			error => {
				dispatch(failure(error.toString()))
				dispatch(alertActions.error(error.toString()))
			}
		)
	}

	function request() {
		return { type: customerConstants.GET_CUSTOMER_INFO_BY_AUTH_REQUEST }
	}

	function success(customer_info) {
		return { type: customerConstants.GET_CUSTOMER_INFO_BY_AUTH_SUCCESS, customer_info }
	}

	function failure(error) {
		return { type: customerConstants.GET_CUSTOMER_INFO_BY_AUTH_FAILURE, error }
	}
}

function bookingCustomer(data) {
	return dispatch => {
		dispatch(request())

		customerService.bookingCustomer(data).then(
			response => {
				setTimeout(() => {
					dispatch(success(response))
				}, 500)
			},
			error => {
				dispatch(failure(error.toString()))
				dispatch(alertActions.error(error.toString()))
			}
		)
	}

	function request() {
		return { type: customerConstants.NEW_BOOK_CUSTOMER_REQUEST }
	}

	function success(response) {
		return { type: customerConstants.NEW_BOOK_CUSTOMER_SUCCESS, response }
	}

	function failure(error) {
		return { type: customerConstants.NEW_BOOK_CUSTOMER_FAILURE, error }
	}
}

function deleteBookingCustomer(id) {
	return dispatch => {
		dispatch(request(id))

		customerService.deleteBookingCustomer(id).then(
			response => {
				setTimeout(() => {
					dispatch(success(id))
				}, 500)
			},
			error => {
				dispatch(failure(error.toString()))
				dispatch(alertActions.error(error.toString()))
			}
		)
	}

	function request() {
		return { type: customerConstants.DELETE_BOOK_CUSTOMER_REQUEST }
	}

	function success(id) {
		return { type: customerConstants.DELETE_BOOK_CUSTOMER_SUCCESS, id }
	}

	function failure(error) {
		return { type: customerConstants.DELETE_BOOK_CUSTOMER_FAILURE, error }
	}
}
